import client from './client'
import type { OrganisationCredits } from '@/types/credits'

export async function fetchOrganisationCredits(organisationId: number): Promise<OrganisationCredits> {
  const { data } = await client.get<{ data: OrganisationCredits }>(
    `/admin/organisations/${organisationId}/credits`,
  )
  return data.data
}

export async function adjustOrganisationCredits(
  organisationId: number,
  amount: number,
): Promise<OrganisationCredits> {
  const { data } = await client.post<{ data: OrganisationCredits }>(
    `/admin/organisations/${organisationId}/credits/adjustments`,
    { amount },
  )
  return data.data
}
